import { Spacing } from '@persona-id/design-tokens';
import { components, SingleValueProps } from 'react-select';
import styled from 'styled-components';

import CaseStatusSticker from 'dashboard/components/CaseStatusSticker';
import { OptionType } from 'dashboard/components/ReactSelect';
import { CaseStateColor } from 'dashboard/models/case-template';

const Container = styled('div')`
  display: flex;
  align-items: center;
  column-gap: ${Spacing[2]};
`;

const CaseStatusColorContainer = (props: SingleValueProps<OptionType<CaseStateColor>>) => {
  return (
    <components.SingleValue {...props} innerProps={{ ...props.innerProps }}>
      <Container>
        <CaseStatusSticker caseState={{ name: 'Status', color: props.data.value }} />
        <span>{props.data.label}</span>
      </Container>
    </components.SingleValue>
  );
};

export default CaseStatusColorContainer;
